import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const PRIMARY_DIAGNOSIS_WARNING_TEXT = "Incorrect primary diagnosis";
export const PRIMARY_PROCEDURE_WARNING_TEXT = "Incorrect primary procedure";
export const DUPLICATE_ICD10_CODE_WARNING_TEXT = "Duplicate ICD-10 code - may be correct, but please review";
export const ORPHANED_ASTERISK_CODE_WARNING_TEXT =
  "Asterisk code present with none of its dagger codes - a code is likely missing";

export const MISSING_ASTERISK_CODE_WARNING_TEXT =
  "Dagger code present without its only asterisk code - a code is likely missing";

export const ORPHANED_ASTERISK_CHECK_FAILED_TEXT =
  "The dagger/asterisk check could not run - please check dagger/asterisk pairs manually";

export const WarningFlag = ({ text }: { text: string }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" aria-label={text} className="shrink-0 cursor-help">
          <span aria-hidden="true">🚩</span>
        </button>
      </TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export const RESTRICTION_CHECK_FAILED_TEXT =
  "The sex or age check could not run - please check codes against the patient's sex and age manually";

const CheckFailedNotice = ({ text }: { text: string }) => (
  <p role="alert" className="mb-1 flex items-center gap-1 text-xs text-amber-700">
    <span aria-hidden="true">🚩</span>
    {text}
  </p>
);

export const OrphanedAsteriskCheckFailedNotice = () => <CheckFailedNotice text={ORPHANED_ASTERISK_CHECK_FAILED_TEXT} />;

export const RestrictionCheckFailedNotice = () => <CheckFailedNotice text={RESTRICTION_CHECK_FAILED_TEXT} />;
